import React, { useEffect } from "react";
import './drafts.scss';
import ReactGA from 'react-ga4';

import Drafts from "./drafts";
import Suggestions from "./suggestions";

const DraftsWrapper = () => {

    useEffect(() => {
        ReactGA.send({ hitType: 'pageview', page: `/drafts` })
    }, [])

    return (
        <div style={{ position: 'relative', width: '100%', height: '100%', minHeight: '400px' }}>
            <Drafts />
            <Suggestions />
        </div>
    )
}

export default DraftsWrapper;